

import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import SingleArticle from './SingleArticle';
import serv3 from '../assets/blogg.webp';
import blog1 from '../assets/blog1.jpeg';
import blog2 from '../assets/blog2.png';
import blog3 from '../assets/blog3.png';
import post1 from '../assets/blog/1.webp';
import post2 from '../assets/blog/2.webp';
import post3 from '../assets/blog/3.webp';
import post4 from '../assets/blog/4.webp';
import post5 from '../assets/blog/5.webp';
import post6 from '../assets/blog/6.webp';
import post7 from '../assets/blog/7.webp';

import gal1 from '../assets/blog/gal1.webp';
import gal2 from '../assets/blog/gal2.webp';
import gal3 from '../assets/blog/gal3.webp';
import gal4 from '../assets/blog/gal4.webp';
import gal5 from '../assets/blog/gal5.webp';

const articles = [

  {
    id: 3,
    title: 'Rwanda Moves to Implement Occupational Health and Safety Standards',
    author: 'Author Name', // Replace 'Author Name' with the correct author's name if needed
    date: 'Published on 11/11/2024', // Adjust if the publication date is different
    imgSrc: `${gal1}`,
    content: `
    <div style="font-family: Arial, sans-serif; line-height: 1.8; color: #333; padding: 1px; margin: auto; text-align: justify;">
        <p style="font-size: 18px; margin-bottom: 18px;">As one of the fastest developing countries, Rwanda’s need for robust occupational health and safety measures has become increasingly critical. Despite leading in many governance aspects, Rwanda still faces challenges in ensuring workplace safety.</p>
        
        <h3 style="font-size: 18px; margin-bottom: 18px;">Current Challenges</h3>
        <p style="font-size: 18px; margin-bottom: 18px;">Even with existing laws and policies, many workers continue to encounter hazards jeopardizing their health and well-being due to negligence. High rates of accidents and illnesses persist in certain industries, highlighting the necessity for ongoing vigilance and improvement.</p>
        
        <h3 style="font-size: 18px; margin-bottom: 18px;">Historical Progress</h3>
        <p style="font-size: 18px; margin-bottom: 18px;">Rwanda made significant strides in 2014 by adopting its first National Occupational Safety and Health Policy and establishing various laws and regulations. However, these efforts have seen minimal implementation over the past decade.</p>

        <p style="font-size: 18px; margin-bottom: 18px;">According to OHS Works Co Ltd Managing Director, Mr Sam Butare, high-risk sectors such as mining, construction, and certain industries, including steel rolling mills and the fishing industry, have witnessed numerous workplace-related accidents due to a lack of measures and know-how.</p>

        <p style="font-size: 18px; margin-bottom: 18px;">The International Labour Organization (ILO) estimates that millions of workers worldwide are affected by work-related injuries and illnesses each year, with over 2.3 million fatalities annually due to occupational accidents and diseases.</p>
        
        <h3 style="font-size: 18px; margin-bottom: 18px;">Global Standards and Local Implementation</h3>
        <p style="font-size: 18px; margin-bottom: 18px;">In June 2022, the International Labour Conference included "a safe and healthy working environment" in the ILO's framework of fundamental principles and rights at work, recognizing the Occupational Safety and Health Convention, 1981 (No. 155) and the Promotional Framework for Occupational Safety and Health Convention, 2006 (No. 187) as fundamental conventions.</p>

        <p style="font-size: 18px; margin-bottom: 18px;">While Rwanda acknowledges the ILO’s resolve, enforcement of its laws and policies since 2014 has been minimal compared to other initiatives like the plastic ban, which saw strong enforcement and near-total compliance since 2008.</p>

        <h3 style="font-size: 18px; margin-bottom: 18px;">Enhancing Workplace Safety: A Way Forward</h3>
        <p style="font-size: 18px; margin-bottom: 18px;">An interactive panel discussion on “Enhancing Workplace Safety in Rwanda” at the first Health and Safety Conference 2024, organized by OHS Works Ltd on October 25, 2024, laid out how Rwanda can implement occupational health and safety.</p>

        <p style="font-size: 18px; margin-bottom: 18px;"><strong>Dr. Jack Ngarambe</strong>, Director General Urbanization, Housing, and Human Settlement, Ministry of Infrastructure, highlighted three main reasons for the lack of enforcement:</p>
        
        <ul style="font-size: 18px; margin-bottom: 18px;">
            <li><strong>Lack of Awareness</strong>: Many employers, especially in the construction sector, are unaware of the existing guidelines. “This requires training of company owners to make sure the employees are aware of the guidelines,” said Ngarambe. “In the future, the federation of engineers will demand constructors prove that employees are equipped with this knowledge.”</li>
            <li><strong>Deliberate Non-Compliance</strong>: Some company owners are aware of the laws but refuse to comply, particularly in providing Personal Protective Equipment (PPEs) for workers.</li>
        </ul>
        
        <p style="font-size: 18px; margin-bottom: 18px;">To address these issues, Ngarambe suggested increased enforcement and technology adoption, such as robotics and 3D printing, to enhance safety measures and monitor their efficacy.</p>

        <p style="font-size: 18px; margin-bottom: 18px;"><strong>Mr. Felicien Hakizamungu</strong>, Occupational Health and Safety Management System Standards Specialist, Rwanda Standards Board (RSB), emphasized that health and safety standards are now mandatory for all companies, starting with the mining sector. RSB has also adopted international standards like ISO 45001 and ISO 45002 to promote compliance, public awareness, and training.</p>

        <h3 style="font-size: 18px; margin-bottom: 18px;">Environmental and Safety Interconnection</h3>
        <p style="font-size: 18px; margin-bottom: 18px;"><strong>Mrs Beata Akimpaye</strong>, Environmental Compliance and Enforcement Division Manager, Rwanda Environment Management Authority (REMA), discussed the inseparable connection between the environment and workplace safety. “Protecting the lives of workers, especially women and persons with disabilities, is essential as they are part of the environment the government aims to protect,” said Akimpaye.</p>

        <p style="font-size: 18px; margin-bottom: 18px;">She stressed the importance of measures such as maintaining cleanliness, using environmentally friendly equipment, and ensuring accessibility for individuals with disabilities.</p>

        <h3 style="font-size: 18px; margin-bottom: 18px;">Economic Implications</h3>
        <p style="font-size: 18px; margin-bottom: 18px;"><strong>Dr. Billy Sebatware</strong>, Director of Pension Benefits Division at Rwanda Social Security Board (RSSB), highlighted the financial costs of non-compliance. In 2022, RSSB paid Rwf65 million in compensation for work-related accidents, with figures rising to over Rwf1.63 billion in 2023 and Rwf1.10 billion so far in 2024.</p>

        <p style="font-size: 18px; margin-bottom: 18px;">Sebatware noted that educating employers and inspecting workplace compliance is crucial to reducing these costs. “There is a low compliance and a poor mindset, and this has led to significant compensation costs,” he said.</p>

        <h3 style="font-size: 18px; margin-bottom: 18px;">The Path Forward</h3>
        <p style="font-size: 18px; margin-bottom: 18px;">The conference participants called for concrete actions.</p>

        <p style="font-size: 18px; margin-bottom: 18px;">Speaking on behalf of the Minister of Public Service and Labour, <strong>Mr Patrick Kananga</strong>, the Chief Labour and Decent Work Administrator, at the Ministry, emphasized the need for strong enforcement, similar to the plastic bag ban. “We need to implement this just as the law on plastic bags. You implement it or face penalties,” said Kananga.</p>

        <p style="font-size: 18px; margin-bottom: 18px;">Private sector employer, <strong>Mr Benjamin Gasamagera</strong>, CEO of Safari Center, called for incentives for enterprises already implementing safety measures. Fresh graduate <strong>Mr Bertrand Iradukunda</strong> suggested forming a network of trained agents to monitor compliance levels.</p>

        <p style="font-size: 18px; margin-bottom: 18px;">Closing the conference on behalf of the Minister in charge of Emergency Management (MINEMA), <strong>Mrs Christine Niyotwambaza Hitimana</strong>, the Director General of Surveillance and Preparedness at the Ministry, endorsed the conference's outcomes and recommended a public–private partnership (PPP) for implementation.</p>

        <p style="font-size: 18px; margin-bottom: 18px;"><a href="https://ohsworks.rw/media/photos" style="color: #0066cc; text-decoration: none;">Please see photos from the conference CLICK HERE</a></p>
    </div>
    `,
    gallery: [
        { src: `${gal1}`, caption: "Main Conference Overview" },
        { src: `${gal2}`, caption: "Dr. Jack Ngarambe, Director General Urbanization, Housing, and Human Settlement, Ministry of Infrastructure" },
        { src: `${gal3}`, caption: "Dr. Billy Sebatware, Director of Pension Benefits Division at Rwanda Social Security Board (RSSB)" },
        { src: `${gal4}`, caption: "Mr Benjamin Gasamagera, CEO of Safari Center" },
        { src: `${gal5}`, caption: "Mrs Beata Akimpaye, Environmental Compliance and Enforcement Division Manager, Rwanda Environment Management Authority (REMA)" }
    ]
},

{
  id: 2,
  title: 'OHS Works Ltd Holds Rwanda’s First Occupational Health and Safety Conference',
  author: 'Mwasa Fred',
  date: 'Published on 25/10/2024',
  imgSrc: `${post7}`,
  content: ` 
  
  <div style="font-family: Arial, sans-serif; line-height: 1.8; color: #333; padding: 1px; margin: auto; text-align: justify;">

<p style="font-size: 18px; margin-bottom: 18px;">This October 25, 2024, Kigali saw the launch of Rwanda's inaugural Occupational Health and Safety (OHS) Conference, gathering stakeholders committed to elevating workplace safety.</p>

<p style="font-size: 18px; margin-bottom: 18px;">Organized by <strong>OHS Works Co Ltd</strong>, the event drew professionals, government leaders, and industry representatives to explore strategies for creating safer work environments, closing gaps in OHS standards, and fostering a national safety culture.</p>

<p style="font-size: 18px; margin-bottom: 18px;">Delivering the speech of <strong>Hon. Christine Nkulikiyinka</strong>, the Minister of Public Service and Labour, <strong>Mr Patrick Kananga</strong>, the Ministry's Chief Labour and Decent Work Administrator, highlighted the importance of the conference in implementing existing OHS policies established since 2014.</p>

<p style="font-size: 18px; margin-bottom: 18px;">He acknowledged challenges in law enforcement and gaps in employer compliance, calling on employers and employees to share responsibility for safety.</p>

<p style="font-size: 18px; margin-bottom: 18px;">Kananga emphasized that a commitment to OHS aligns with International Labour Organization (ILO) data showing over 2.3 million annual deaths from work-related causes globally, costing countries approximately 4% of their GDP.</p>

<p style="font-size: 18px; margin-bottom: 18px;">Kananga noted Rwanda's steady progress in implementing OHS policies, referencing the National Occupational Safety and Health Policy established in 2014. However, he acknowledged persistent challenges, with some industries still experiencing high rates of work-related accidents.</p>

<p style="font-size: 18px; margin-bottom: 18px;">He advocated for reinforcing OHS laws and creating a safety culture to protect workers from both physical injuries and mental stress. “<em>We must ensure that every worker returns home safely</em>,” Kananga urged, emphasizing the significant role that safe work environments play in enhancing national productivity.</p>

<p style="font-size: 18px; margin-bottom: 18px;"><strong>Mr Sam Butare</strong>, Managing Director of OHS Works Co Ltd, echoed the need to develop a national safety culture. “<em>The concept of health and safety at work is still underdeveloped in Rwanda</em>,” he observed, citing a lack of awareness and law enforcement. Butare stressed the need for training and consistent awareness campaigns.</p>

<p style="font-size: 18px; margin-bottom: 18px;">He also outlined plans for establishing a dedicated training center to ensure ongoing safety education and regulatory compliance.</p>

<p style="font-size: 18px; margin-bottom: 18px;">Butare underscored the importance of investor engagement, noting that ignoring safety results in financial losses for businesses, employees, and insurers. He identified mining, construction, steel mills, and the fishing industry as high-risk sectors with frequent accidents due to insufficient safety practices.</p>

<p style="font-size: 18px; margin-bottom: 18px;">“<em>Implementing OHS laws is crucial, much like Rwanda’s successful ban on plastic bags</em>,” he said, signaling a firm commitment to workplace safety.</p>

<p style="font-size: 18px; margin-bottom: 18px;">The conference highlighted that implementing OHS policies could reduce financial losses, drive economic productivity, and foster sustainable development.</p>

<p style="font-size: 18px; margin-bottom: 18px;">The Minister in charge of Emergency Management (MINEMA), <strong>Maj Gen (Rtd) Albert Murasira</strong> was represented at the conference by <strong>Christine Niyotwambaza Hitimana</strong>, Director General of Surveillance and Preparedness at MINEMA. She advocated for public–private partnerships to support the implementation of conference recommendations.</p>

<p style="font-size: 18px; margin-bottom: 18px;">She emphasized the importance of environmental and disaster impact assessments for new business ventures.</p>

<p style="font-size: 18px; margin-bottom: 18px;">The conference featured a panel of experts from government, private sector, and civil society, providing a well-rounded discussion on occupational health and safety practices and challenges.</p>

<p style="font-size: 18px; margin-bottom: 18px;"><strong>Gloria Mukamabano</strong>, a senior presenter at Rwanda Television, moderated the session, facilitating dynamic exchanges and a Q&A segment.</p>

<p style="font-size: 18px; margin-bottom: 18px;">During the Q&A, business executives in the occupational health and safety sector joined the discussion, contributing valuable insights.</p>

<p style="font-size: 18px; margin-bottom: 18px;">Alongside the panel, an exhibition showcased innovative safety solutions, offering attendees opportunities to network and explore practical tools for enhancing workplace safety in Rwanda.</p>

</div>

  
  `,
  gallery: [
    { src: `${post3}`, caption: "Mr Patrick Kananga, the Ministry's Chief Labour and Decent Work Administrator" },
    { src: `${post2}`, caption: "" },
    { src: `${post4}`, caption: "Mr Sam Butare, Managing Director of OHS Works Co Ltd" },
    { src: `${post5}`, caption: "Gloria Mukamabano, a senior presenter at Rwanda Television" },
    { src: `${post6}`, caption: "" },
    { src: `${post7}`, caption: "" },
  ]
},

  {
    id: 1,
    title: 'CONFERENCE PRESS RELEASE',
    author: 'Mwasa Fred',
    date: 'Published on 25/10/2024',
    imgSrc: `${blog3}`,
    content: `
    <div class="text-justify" style="padding: 1px; font-family: Arial, sans-serif; color: #333;">
      <p style="font-size: 18px;  margin-top: 0;">
        Kigali, 21 October 2024 – OHS Works Co Ltd is proud to announce Rwanda’s first-ever Occupational Health and Safety (OHS) Conference, scheduled for 25 October 2024, in Kigali, Rwanda. This inaugural event marks a significant milestone in promoting workplace safety and health standards across the country.
   
        Industry leaders, policymakers, and professionals from both the public and private sectors are called to participate in this critical platform, which will address the growing need for robust occupational health and safety standards.
      </p>

      <h2 style="font-size: 18px; font-weight: bold; color: #000; margin-top: 18px;">
        What is Occupational Health and Safety?
      </h2>
      <p style="font-size: 16px;">
        Occupational Health and Safety (OHS) is a multidisciplinary field that focuses on the health, safety, and welfare of workers in all industries and the public sector. Its primary goal is to create safe work environments by implementing systems, standards, and practices that prevent workplace injuries, illnesses, and accidents. Key components of OHS include:
      </p>

      <ul style="font-size: 16px; line-height: 1.6; margin-left: 0px;">
        <li style="margin-bottom: 10px;"><strong>Risk Assessment:</strong> Identifying hazards and implementing control measures to reduce or eliminate risks.</li>
        <li style="margin-bottom: 10px;"><strong>Compliance with Regulations:</strong> Ensuring that organizations meet local, national, and international safety laws.</li>
        <li style="margin-bottom: 10px;"><strong>Health and Safety Programs:</strong> Ongoing employee training and awareness campaigns.</li>
        <li style="margin-bottom: 10px;"><strong>Workplace Inspections and Audits:</strong> Regular monitoring and evaluation of safety standards.</li>
        <li style="margin-bottom: 10px;"><strong>Emergency Preparedness:</strong> Having plans and procedures in place for responding to workplace incidents or disasters.</li>
      </ul>

      <h2 style="font-size: 18px; font-weight: bold; color: #000; margin-top: 18px;">
        Our Esteemed Sponsors
      </h2>
      <p style="font-size: 16px;">
        The conference will feature remarks by the Ministry of Public Service and Labour, Ministry of Infrastructure, and Ministry in charge of Emergency Management. There will be engaging discussions on workplace safety led by key speakers from Rwanda Social Security Board (RSSB), the Rwanda Extractive Industry Workers Union (REWU), Safari Centre Ltd, NPD Ltd, Pink Mango Group, Rwanda Standards Board (RSB), and Rwanda Environment Management Authority (REMA).
      </p>

      <h2 style="font-size: 18px; font-weight: bold; color: #000; margin-top: 18px;">
        Call to Action
      </h2>
      <p style="font-size: 16px;">
        We invite all stakeholders to join us at this landmark event to collaborate on actionable strategies that will enhance workplace safety across Rwanda. Your participation will contribute to building a safer, healthier workforce and foster growth across all sectors.
      </p>

      <h2 style="font-size: 18px; font-weight: bold; color: #000; margin-top: 18px;">
        About OHS Works Co Ltd
      </h2>
      <p style="font-size: 16px;">
        OHS Works Co Ltd is a leading provider of comprehensive occupational health and safety solutions. We are committed to raising safety standards through strategic consulting, conferences, training, and the supply of safety equipment across industries in Rwanda.
      </p>

      <div style="border: 1px solid #ddd; padding: 15px; margin-top: 18px;">
        <h3 style="font-size: 18px; font-weight: bold; margin: 0; color: #333;">Event Details</h3>
        <ul style="font-size: 16px; list-style-type: none; padding-left: 0; margin-top: 10px;">
          <li><strong>Date:</strong> 25 October 2024</li>
          <li><strong>Venue:</strong> M Hotel, Kigali-Rwanda</li>
          <li><strong>Time:</strong> 9:00 AM - 3:00 PM</li>
          <li><strong>Registration:</strong> Open now at <a href="http://www.ohsworks.rw" style="color: #0066cc; text-decoration: underline;">www.ohsworks.rw</a></li>
        </ul>
      </div>

      <div style="border: 1px solid #ddd; padding: 15px; margin-top: 18px;">
        <p style="font-size: 16px; font-weight: bold; margin: 0; color: #333;">For inquiries or sponsorship opportunities, please contact:</p>
        <p style="font-size: 16px; margin: 10px 0 0;">
          Sam Butare<br />
          Managing Director<br />
          OHS Works Co Ltd<br />
          Email: <a href="mailto:sam.butare@ohsworks.rw" style="color: #0066cc; text-decoration: underline;">sam.butare@ohsworks.rw</a><br />
          Tel. +250 788 590 151
        </p>
      </div>
    </div>
  `,
  gallery: []
  },
    
   
  
    ];

export default function Blog() {
  const [selectedArticle, setSelectedArticle] = useState(null);

  if (selectedArticle) {
    return <SingleArticle article={selectedArticle} goBack={() => setSelectedArticle(null)} />;
  }

  return (
    <div>
      <Header />
      <section className="relative w-full bg-gray-50 py-20 lg:py-28">
        <img
          src={serv3}
          alt="Hero Image"
          className="w-full h-40 md:h-72 object-cover"
        />
        <div className="grid grid-cols-1 p-4 w-[90%] mt-12 md:grid-cols-2 lg:grid-cols-3 gap-8 text-left mx-auto">
          {articles.map(article => (
            <article
              key={article.id}
              className="bg-white shadow-lg rounded-lg overflow-hidden transition-all duration-300 transform hover:scale-105 cursor-pointer"
              onClick={() => setSelectedArticle(article)}
            >
              <div className="relative">
                <img
                  src={article.imgSrc}
                  alt=""
                  className="h-60 w-full object-cover transition-transform duration-300 transform hover:scale-110"
                />
              </div>
              <div className="p-6">
                <h3 className="font-bold  text-xl text-gray-800 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-gray-400">{article.date}</p>
                {/* <p className="text-sm text-gray-500 mt-1 mb-4 font-medium">{article.author}</p> */}
                {/* <p className="text-sm text-gray-700 line-clamp-3 leading-relaxed">
                {{ __html:article.content}}
                </p> */}
                <div
              className="text-md leading-relaxed line-clamp-3  text-gray-700 mb-8"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />
                <div className="flex items-center mt-4">
                  <button className="text-indigo-600 hover:text-indigo-800 font-semibold text-sm">
                    Read More
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
